import React from "react";
import { Line } from "react-chartjs-2";
import { formatGnf, STATS_COLORS, lineChartOptions, lineChartOptionsCount } from "./statsChartSetup";

const StatsTabEvolution = ({ data }) => {
  if (!data?.evolution?.length) {
    return (
      <div className="stats-empty">
        Aucune donnée d&apos;évolution pour les filtres sélectionnés.
      </div>
    );
  }

  const ev = data.evolution;
  const labels = ev.map((e) => e.label);

  const lineData = {
    labels,
    datasets: [
      {
        label: "Net total",
        data: ev.map((e) => e.salaire_net),
        borderColor: STATS_COLORS.primary,
        backgroundColor: STATS_COLORS.primarySoft,
        fill: true,
        tension: 0.35,
        pointRadius: 4,
        pointHoverRadius: 7,
      },
      {
        label: "Net verrouillé",
        data: ev.map((e) => e.salaire_net_verrouille),
        borderColor: STATS_COLORS.success,
        backgroundColor: "transparent",
        tension: 0.35,
        pointRadius: 3,
        borderDash: [0],
      },
      {
        label: "Net non verrouillé",
        data: ev.map((e) => e.salaire_net_non_verrouille),
        borderColor: STATS_COLORS.warning,
        backgroundColor: "transparent",
        tension: 0.35,
        pointRadius: 3,
      },
    ],
  };

  const periodesData = {
    labels,
    datasets: [
      {
        label: "Périodes verrouillées",
        data: ev.map((e) => e.nb_periodes_verrouillees),
        borderColor: STATS_COLORS.success,
        backgroundColor: STATS_COLORS.successSoft,
        fill: true,
        tension: 0.3,
        yAxisID: "y",
      },
      {
        label: "Périodes ouvertes",
        data: ev.map((e) => e.nb_periodes_ouvertes),
        borderColor: STATS_COLORS.warning,
        backgroundColor: STATS_COLORS.warningSoft,
        fill: true,
        tension: 0.3,
        yAxisID: "y",
      },
    ],
  };

  return (
    <div className="stats-tab-content">
      <div className="stats-panel mb-4">
        <h6 className="stats-panel-title">Évolution du salaire net (GNF)</h6>
        <p className="stats-hint">Courbe mensuelle — distinction verrouillé / non verrouillé</p>
        <div className="stats-chart-box stats-chart-tall">
          <Line
            data={lineData}
            options={{
              ...lineChartOptions,
              plugins: {
                ...lineChartOptions.plugins,
                legend: { ...lineChartOptions.plugins.legend, position: "top" },
                tooltip: {
                  ...lineChartOptions.plugins.tooltip,
                  callbacks: { label: (ctx) => `${ctx.dataset.label}: ${formatGnf(ctx.raw)} GNF` },
                },
              },
            }}
          />
        </div>
      </div>

      <div className="stats-panel">
        <h6 className="stats-panel-title">Évolution du nombre de périodes</h6>
        <div className="stats-chart-box stats-chart-medium">
          <Line
            data={periodesData}
            options={{
              ...lineChartOptionsCount,
              plugins: {
                ...lineChartOptionsCount.plugins,
                legend: { ...lineChartOptionsCount.plugins.legend, position: "top" },
                tooltip: {
                  ...lineChartOptionsCount.plugins.tooltip,
                  callbacks: { label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}` },
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default StatsTabEvolution;
